import styled from 'styled-components';

export const StyledLoyaltyCompany = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  max-width: 1440px;
  padding: 48px 20px;
  margin: 0 auto;
  background-color: ${(props) => props.$backgroundColor || '#fff'};

  @media (max-width: 767px) {
    padding: 32px 16px;
  }

  h2,
  h3,
  p {
    margin: 0;
    color: #000;
  }

  h2 {
    font-size: 32px;
    line-height: 50px;
    font-weight: 700;
  }

  h3 {
    font-size: 20px;
    line-height: 40px;
    font-weight: 700;
  }

  .section {
    display: flex;
    flex-direction: column;
    row-gap: 16px;

    p {
      font-size: 18px;
      line-height: 24px;
      margin-bottom: 24px;
    }
  }
  .main_description {
    max-width: 735px;
  }

  .back_section {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    a {
      color: #000;
    }
  }

  .back_arrow_icon {
    font-size: 14px;
    width: 14px;
    height: 14px;
  }
  .img_container {
    padding: 0;
    width: inherit;
    height: 425px;
    position: relative;
    overflow: hidden;
    img {
      position: absolute;
      top: -100%;
      bottom: -100%;
      margin: auto;
    }
    @media (max-width: 767px) {
      width: 100%;
      position: unset;
      overflow: unset;
      height: unset;
      img {
        position: unset;
        object-fit: contain;
        width: inherit;
      }
    }
  }
  .infor_section {
    display: grid;
    grid-template-areas:
      'longdes longdes longdes longdes longdes offers'
      'subheading subheading subheading subheading subheading offers'
      '. . . . . offers';
    grid-gap: 24px 32px;
    @media (max-width: 767px) {
      grid-gap: 8px;
      grid-template-areas:
        'offers offers offers offers offers offers'
        'subheading subheading subheading subheading subheading subheading'
        'longdes longdes longdes longdes longdes longdes'
        'companyinfo companyinfo companyinfo companyinfo companyinfo companyinfo';
    }
  }
  .company_info {
    grid-area: companyinfo;
  }

  .sub_heading_section {
    grid-area: subheading;
    .description_img_container {
      width: 100%;
      margin-bottom: 24px;
      img {
        width: inherit;
      }
    }
    .option_img_container {
      width: 100%;
      margin-bottom: 24px;
      img {
        width: inherit;
      }
    }
    @media (max-width: 767px) {
      h3 {
        margin-bottom: 24px;
        line-height: unset;
      }
    }
  }
  .long_description_section {
    grid-area: longdes;
    .description_img_container {
      width: 100%;
      margin-bottom: 24px;
      img {
        width: inherit;
      }
    }
  }
  .offer_section {
    grid-area: offers;
    display: flex;
    flex-direction: column;
  }
  .offer_wrapper {
    background-color: #fff;
    margin-bottom: 32px;
    border-radius: 4px;
    padding: 32px;
    h3 {
      margin-bottom: 24px;
    }
    .logo_wrapper {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 24px;
      .logo_img_container {
        max-width: 225px;
        max-height: 80px;
        img {
          width: -webkit-fill-available;
        }
      }
    }
    p {
      margin-bottom: 16px;
    }
    .benefit_btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      border-radius: 8px;
      background: #fbf3c1;
      padding: 12px;
    }
    .benefit_btn_text {
      color: #164144;
      font-size: 16px;
      font-weight: 800;
    }
    .info_paragraph {
      display: flex;
      align-items: center;
    }
    .info_icons {
      margin-right: 10px;
      font-size: 18px;
    }
    .info_link {
      color: #111;
    }
  }
`;
